import {
	REFRESH_PHOTOS,
	SET_PHOTOS,
	ADD_PHOTO,
	UPDATE_PHOTO,
	GET_PHOTO,
	FINISH_GET_PHOTO,
	DELETE_PHOTO
} from './types';
import { removeDuplicateID } from 'utils/utils';

const initialState = {
	initialize: true,
	photos: [],
	loadMore: true,
	limit: 10,
  	total: 0,
	isRequesting:false
};

const reducer = (state = initialState, {type, payload}) => {

	switch (type) {

		case REFRESH_PHOTOS:
			return {
				...state,
				initialize: true,
				loadMore: true,
				photos: [],
				isRequesting:false
			}

		case SET_PHOTOS:
			let newSetPhoto = [...state.photos, ...payload.photos]; //add photo and pagination purpose
			const filtered = removeDuplicateID(newSetPhoto);
			return {
				...state,
				initialize: false,
				photos: [...filtered],
				total: payload.total,
				loadMore: payload.loadMore,
				isRequesting:false
			}

		case ADD_PHOTO:
			let newSet = [...state.photos, payload]; //add photo and pagination purpose
			const uniqueArray = removeDuplicateID(newSet);
			return {
				...state,
				photos: uniqueArray
			}
		case GET_PHOTO:
			return {
			...state,
			isRequesting: true,
			};
	
		case FINISH_GET_PHOTO:
			return {
			...state,
			isRequesting: false,
			loadMore: payload.loadMore,
			};
		

		case UPDATE_PHOTO:
			let updatedPhotos = state.photos.map((r, i) => {
				if (r.id === payload.id) {
					return payload
				}
				return r;
			});
			
			return {
				...state,
				photos: updatedPhotos
			}
		case DELETE_PHOTO:
			let removedPhotos = state.photos.filter((r) =>  r.id !== payload.id);
			
			return {
				...state,
				photos: removedPhotos
			}

		default:
			return state;

	}

}

export default reducer